import { PAGE_LEVEL } from '@/constants';

/**
 * IRM 内嵌页路由：在 BRM 内通过 iframe 承载 webirm 页面
 * query.path 为已剥离 /irm 前缀的 webirm 真实路由
 */
export default {
  path: '/irm-embed',
  redirect: '/irm-embed/index',
  children: [
    {
      path: 'index',
      name: 'irmEmbedIndex',
      component: () => import('@/pages/irmEmbed/index.vue'),
      meta: {
        componentName: 'IrmEmbedIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'IRM',
        keepAlive: false,
        // 未纳入后端菜单权限，跳过路由守卫菜单鉴权，否则会被重定向到 /res/not-found
        requireAuth: false
      }
    }
  ]
};
